import React, { useEffect, useContext } from 'react';
import { store } from '../reducer';
import Form from './Form';
import { makeStyles } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import CategoryProvider from './CategoryProvider';
import List from './List';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const Categories = () => {
  useTitle('مدیریت نقش ها')
  const classes = useStyles();
  const { dispatch, showMessage, showError } = useContext(store);

  useEffect(() => {
    dispatch({
      type: 'CHANGE_TITLE_SUBTITLE',
      payload: { title: 'مدیریت نقش‌ها', subtitle: 'افزودن/ویرایش نقش‌ها' },
    });
  }, []);

  return (
    <CategoryProvider showError={showError} showMessage={showMessage}>
      <div className={classes.root}>
        <Form />
        <List />
      </div>
    </CategoryProvider>
  );
};

export default React.memo(Categories);
